import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-036ec788"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m_pesa_div" }
const _hoisted_2 = { class: "panel_div" }
const _hoisted_3 = { class: "pay_amount" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Payment Amount", -1))
const _hoisted_5 = { class: "price" }
const _hoisted_6 = { class: "panel_div" }
const _hoisted_7 = { class: "pay_amount" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "" }, "Payment Methods", -1))
const _hoisted_9 = { class: "price" }
const _hoisted_10 = { class: "panel_div" }
const _hoisted_11 = { class: "m_pesa_memo_content" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " In case you cannot receive M-PESA popup, you can also try paybill as follows ", -1))
const _hoisted_13 = { class: "steps_list" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createTextVNode("1.Go to "),
  /*#__PURE__*/_createElementVNode("b", null, "M-PESA"),
  /*#__PURE__*/_createTextVNode(" on your phone")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createTextVNode("2.Select \""),
  /*#__PURE__*/_createElementVNode("b", null, "Payment Services"),
  /*#__PURE__*/_createTextVNode("\".")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createTextVNode("3.Go to \""),
  /*#__PURE__*/_createElementVNode("b", null, "Pay Bill"),
  /*#__PURE__*/_createTextVNode("\" Option.")
], -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode("4.Enter Bussiness No.")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("5.Enter Account No: ")
const _hoisted_19 = { class: "key_div" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" COPY ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("6.Enter Amount ")
const _hoisted_22 = /*#__PURE__*/_createTextVNode(".")
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createTextVNode(" 7.Enter your "),
  /*#__PURE__*/_createElementVNode("b", null, "M-PESA PIN"),
  /*#__PURE__*/_createTextVNode(". ")
], -1))
const _hoisted_24 = { class: "panel_div btn_div" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("I Have Paid")
const _hoisted_26 = { class: "panel_div btn_div" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Using Other Online Payments")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_menu = _resolveComponent("header-menu")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_button = _resolveComponent("van-button")!
  const _directive_clipboard = _resolveDirective("clipboard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_header_menu, {
      title: "Payment",
      backgroundColor: "white",
      fontColor: "#190900"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, _toDisplayString($setup.currencyUnit) + " " + _toDisplayString($setup.payment_amount.thousands()), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_van_image, {
            src: 'https://image.kilimall.com/kenya/PcImages/mpesa_icon.png'.webpFilters()

          }, null, 8, ["src"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("ul", _hoisted_13, [
          _hoisted_14,
          _hoisted_15,
          _hoisted_16,
          _createElementVNode("li", null, [
            _hoisted_17,
            _createElementVNode("b", null, _toDisplayString($setup.view_datas.biz_content ? $setup.view_datas.biz_content.ofChannels[0].payBill : ''), 1)
          ]),
          _createElementVNode("li", null, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("b", null, _toDisplayString($setup.view_datas.biz_content ? $setup.view_datas.biz_content.ofChannels[0].paySN : ''), 1),
              _withDirectives((_openBlock(), _createBlock(_component_van_button, {
                plain: "",
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _hoisted_20
                ]),
                _: 1
              })), [
                [_directive_clipboard, $setup.message, "copy"],
                [_directive_clipboard, $setup.onCopy, "success"],
                [_directive_clipboard, $setup.onError, "error"]
              ])
            ])
          ]),
          _createElementVNode("li", null, [
            _hoisted_21,
            _createElementVNode("b", null, _toDisplayString($setup.currencyUnit) + " " + _toDisplayString($setup.payment_amount.thousands()), 1),
            _hoisted_22
          ]),
          _hoisted_23
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createVNode(_component_van_button, {
        onClick: $setup.actv_pay_status_fn,
        type: "primary",
        class: "pay_amount_weight"
      }, {
        default: _withCtx(() => [
          _hoisted_25
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createVNode(_component_van_button, {
        onClick: $setup.other_pay_fn,
        plain: "",
        type: "primary"
      }, {
        default: _withCtx(() => [
          _hoisted_27
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}